import { reportError } from 'shared/sentry';

/**
 * Log unexpected call-path errors for debugging and Sentry (skips aborts).
 * @param {unknown} caught
 * @param {string} context
 */
export function logCallError(caught, context) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`[call] ${context}`, caught);
  }
  reportError(caught, context, { tags: { feature: 'matrix_call' } });
}
